import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	edit_definition_modal_header_edit: {
		id: 'search_ai.edit_definition_modal_header_edit',
		defaultMessage: 'Edit definition',
		description: 'Header of the definition modal when user is editing a definition',
	},
	edit_definition_modal_header_create: {
		id: 'search_ai.edit_definition_modal_header_create',
		defaultMessage: 'Add a definition',
		description: 'Header of the definition modal when user is creating a definition',
	},
	edit_definition_modal_subheader_text: {
		id: 'search_ai.edit_definition_modal_subheader_text',
		defaultMessage: 'You can edit definitions to help teammates better understand terms.',
		description: 'Definition modal subheader body text',
	},
	edit_definition_modal_subheader_link_text: {
		id: 'search_ai.edit_definition_modal_subheader_link_text',
		defaultMessage: 'More on editing definitions',
		description: 'Definition modal subheader link text',
	},
	edit_definition_text_box_label: {
		id: 'search_ai.edit_definition_text_box_label',
		defaultMessage: 'Definition',
		description: 'Label above edit definition text editor',
	},
	edit_definition_text_box_label_with_count: {
		id: 'search_ai.edit_definition_text_box_label_with_count',
		defaultMessage:
			'Edit definition, {count} of {max} characters used. Start typing to enter text.',
		description: 'Accessible label for edit definition text editor with character count',
	},
	edit_definition_no_definition: {
		id: 'search_ai.edit_definition_no_definition',
		defaultMessage: 'Enter definition',
		description: 'Error text when user has not entered in definition',
	},
	edit_definition_over_max_length: {
		id: 'search_ai.edit_definition_over_max_length',
		defaultMessage: 'Definition must be {max} characters or fewer.',
		description: 'Error text when user has entered too many characters',
	},
	edit_definition_source_label: {
		id: 'search_ai.edit_definition_source_label',
		defaultMessage: 'Source',
		description: 'Label above edit definition source',
	},
	edit_definition_add_source_label: {
		id: 'search_ai.edit_definition_add_source_label',
		defaultMessage: 'Add a source (optional)',
		description: 'Label above edit definition add optional source',
	},
	edit_definition_restricted_to_label: {
		id: 'search_ai.edit_definition_restricted_to_label',
		defaultMessage: 'Show this definition',
		description: 'Label above edit definition show this definition',
	},
	edit_definition_restricted_to_space_subline: {
		id: 'search_ai.edit_definition_restricted_to_space_subline',
		defaultMessage: 'Previous definition will still show in other spaces.',
		description: 'Label above edit definition show this definition in other spaces',
	},
	edit_definition_restricted_to_site_subline: {
		id: 'search_ai.edit_definition_restricted_to_site_subline',
		defaultMessage: 'Previous definition will still show on other sites.',
		description: 'Label above edit definition show this definition on other sites',
	},
	edit_definition_restricted_to_project_subline: {
		id: 'search_ai.edit_definition_restricted_to_project_subline',
		defaultMessage: 'Previous definition will still show in other projects.',
		description: 'Label above edit definition show this definition on other projects',
	},
	edit_definition_restricted_to_page_subline: {
		id: 'search_ai.edit_definition_restricted_to_page_subline',
		defaultMessage: 'Previous definition will still show on other pages.',
		description: 'Label above edit definition show this definition on other pages',
	},
	edit_definition_restricted_to_blogpost_subline: {
		id: 'search_ai.edit_definition_restricted_to_blogpost_subline',
		defaultMessage: 'Previous definition will still show on other blogposts.',
		description: 'Label above edit definition show this definition on other blogposts',
	},
	edit_definition_source_search_box_placeholder: {
		id: 'search_ai.edit_definition_source_search_box_placeholder',
		defaultMessage: 'Search or paste a Confluence link',
		description: 'Placeholder for search source input box',
	},
	edit_definition_back_button: {
		id: 'search_ai.edit_definition_back_button',
		defaultMessage: 'Back',
		description: 'Text for back definition button',
	},
	edit_definition_update_button: {
		id: 'search_ai.edit_definition_update_button',
		defaultMessage: 'Update',
		description: 'Text for update definition button',
	},
	edit_definition_source_option_metadata_updated_text: {
		id: 'search_ai.edit_definition_source_option_metadata_updated_text',
		defaultMessage: 'Updated',
		description: 'Text of updated metadata of source option',
	},
	edit_definition_update_confirmation_title: {
		id: 'search_ai.edit_definition_update_confirmation_title',
		defaultMessage: 'Definition updated 🎉',
		description: 'Text for definition update confirmation flag title',
	},
	edit_definition_update_confirmation_description: {
		id: 'search_ai.edit_definition_update_confirmation_description',
		defaultMessage: "You've made work clearer for your teammates.",
		description: 'Text for definition update confirmation flag description',
	},
	edit_definition_restricted_to_project_subline_galaxia: {
		id: 'search_ai.edit_definition_restricted_to_project_subline-galaxia',
		defaultMessage: 'Previous definition will still show in other spaces.',
		description: 'Label above edit definition show this definition on other projects',
	},
});
